import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { GeneralService } from '@gs-2.0/core';

const DEFAULT_FORMAT = 'MM/dd/yyyy';

@Pipe({
  name: 'gsDatePattern',
  standalone: true,
  pure: false,
})
export class DatePatternPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;

  constructor(
    private generalService: GeneralService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscription = this.generalService.settings$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(_: unknown): string {
    const config = this.generalService.settings?.response.globalConfig ?? [];
    return config.find(c => c.key === 'dateFormat')?.value || DEFAULT_FORMAT;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
